import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { SaveListingButton } from 'components/SaveButton/SaveListingButton';
import { ShareListingButton } from 'components/ShareListingButton/ShareListingButton';
import { useI18n } from 'i18n/hooks/useI18n';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import type { ApiOrg } from 'modules/listing/orgs/api/types/ApiOrg';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { orgHasListings } from './utils/orgHasListings';

type Props = {
  org: ApiOrg;
  isPreview: boolean;
  mobile: boolean;

  // Save
  saved: boolean;
  onSave: () => Promise<void>;
  onUnsave: () => Promise<void>;
};

export function ViewOrgPageActionButtons({
  org,
  isPreview,
  mobile,
  saved,
  onSave,
  onUnsave,
}: Props) {
  const { i18n } = useI18n();

  return (
    <Box display="flex" flexWrap="wrap" position="relative">
      {orgHasListings(org) && (
        <Box m="4px">
          <Button
            type="link"
            href="#opportunities"
            variant="primary"
            onClick={() =>
              trackClicked('See Opportunities', { type: 'Button Top' })
            }
          >
            {i18n('See opportunities')}
          </Button>
        </Box>
      )}
      <Box m={1}>
        <SaveListingButton
          listingType="ORG"
          disabled={isPreview}
          listingSaved={saved}
          onSaveListing={onSave}
          onUnsaveListing={onUnsave}
          orgDetails={null}
        />
      </Box>
      {!mobile && (
        <Box m={1}>
          <ShareListingButton
            listingId={org.id}
            listingType="ORG"
            listingUrl={org.url}
            disabled={isPreview}
          />
        </Box>
      )}

      <Box m={1}>
        <ListingActionsDropdown
          listingId={org.id}
          listingType="ORG"
          listingUrl={org.url}
          orgDetails={null}
          markAsAppliedButton={null}
        />
      </Box>
    </Box>
  );
}
